import React from 'react';
import './Header.css';

function Header({ menuAberto, setMenuAberto, abrirCarrinho, fecharCarrinho, isScrolled, carrinhoHeaderRef }) {
  return (
    <>
      {/* HEADER MOBILE */}
      <header className="header-gabal header-mobile">
  <div
    className="header-mobile-inner"
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '16px',
      maxWidth: '480px',
      margin: '0 auto',
      width: '100%',
    }}
  >
    {/* ESQUERDA: MENU */}
    <div
      style={{
        width: 64,
        height: 64,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <button
        className="header-action-btn"
        onClick={() => setMenuAberto(true)}
        aria-label="abrir menu"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="4" y1="7" x2="20" y2="7" />
          <line x1="4" y1="12" x2="20" y2="12" />
          <line x1="4" y1="17" x2="20" y2="17" />
        </svg>
      </button>
    </div>

    {/* CENTRO: LOGO */}
    <img
      src={process.env.PUBLIC_URL + "/images/logo-gabal.png"}
      alt="Logo Gabal"
      className="logo-gabal-mobile"
      style={{
        height: 64,
        objectFit: 'contain',
      }}
    />

    {/* DIREITA: CARRINHO */}
    <div
      style={{
        width: 64,
        height: 64,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      ref={carrinhoHeaderRef}
    >
      {!isScrolled ? (
        <button
          className="header-action-btn"
          onClick={abrirCarrinho}
          aria-label="abrir carrinho"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="9" cy="20" r="1" />
            <circle cx="17" cy="20" r="1" />
            <path d="M3 3h2l3.6 12.4a1 1 0 0 0 1 .6h7.8a1 1 0 0 0 1-.8l2-8H6" />
          </svg>
        </button>
      ) : (
        <div
          style={{
            width: 48,
            height: 48,
            visibility: 'hidden',
          }}
        />
      )}
    </div>
  </div>
</header>

      {/* HEADER DESKTOP */}
      <header className="header-gabal header-desktop">
        <div className="container-header">
          {/* Logo */}
          <img
            src={process.env.PUBLIC_URL + "/images/logo-gabal.png"}
            alt="Logo Gabal"
            className="logo-gabal"
          />

          {/* Menu principal */}
          <nav className="menu-gabal">
            <a
              href="https://www.gabal.com.br"
              target="_blank"
              rel="noopener noreferrer"
              >
              Home
            </a>
            <a
              href="https://orcamentos.gabal.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="active"
            >
              Equipamentos/Orçamentos
            </a>
          </nav>

          {/* Social / CTA */}
          <div className="social-buttons">
            <a
              href="https://instagram.com/gabal.audio"
              target="_blank"
              rel="noopener noreferrer"
              className="icon-instagram"
            >
              <i className="fab fa-instagram" />
            </a>
            <a
              href="https://wa.me/5562992461404"
              target="_blank"
              rel="noopener noreferrer"
              className="botao-whatsapp"
            >
              Whatsapp
            </a>
          </div>
        </div>
      </header>

      {/* MENU LATERAL MOBILE (DRAWER) */}
      {menuAberto && (
        <>
          {/* fundo escuro atrás do menu */}
          <div
            className="overlay-menu-mobile"
            onClick={() => setMenuAberto(false)}
          />

          {/* painel lateral */}
          <aside className="drawer-menu-mobile">
            <button
              className="fechar-drawer"
              onClick={() => setMenuAberto(false)}
            >
              ✕
            </button>

            <nav className="drawer-links">
              <a
                href="https://www.gabal.com.br"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMenuAberto(false)}
              >
                Home
              </a>
              <a
                href="https://orcamentos.gabal.com.br"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMenuAberto(false)}
              >
                Equipamentos / Orçamentos
              </a>
            </nav>

            <div className="drawer-social">
  {/* Instagram */}
  <a
    href="https://instagram.com/gabal.audio"
    target="_blank"
    rel="noopener noreferrer"
    className="drawer-social-item"
  >
    <span className="drawer-social-icon">
      {/* Ícone Instagram simples em SVG */}
      <svg
        viewBox="0 0 24 24"
        width="22"
        height="22"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
      </svg>
    </span>
    <span className="drawer-social-text">Instagram</span>
  </a>

  {/* WhatsApp */}
  <a
    href="https://wa.me/5562992461404"
    target="_blank"
    rel="noopener noreferrer"
    className="drawer-social-item whatsapp"
  >
    <span className="drawer-social-icon whatsapp-icon">
      {/* Ícone WhatsApp em SVG */}
      <svg
        viewBox="0 0 24 24"
        width="22"
        height="22"
        fill="currentColor"
      >
        <path d="M20.52 3.48A11.78 11.78 0 0 0 12 .75a11.25 11.25 0 0 0-9.6 16.95L1 23l5.45-1.43a11.27 11.27 0 0 0 5.53 1.41h.01A11.24 11.24 0 0 0 23.25 12a11.8 11.8 0 0 0-2.73-8.52ZM12 21a9.42 9.42 0 0 1-4.8-1.28l-.34-.2-3.23.85.86-3.15-.22-.32A9.39 9.39 0 0 1 12 2.59c5.17 0 9.38 4.1 9.38 9.14S17.17 21 12 21Zm5.16-7.22c-.28-.14-1.7-.84-1.96-.94-.26-.1-.45-.14-.64.14-.19.28-.74.93-.9 1.12-.17.19-.33.2-.61.07-.28-.14-1.19-.46-2.27-1.47-.84-.79-1.41-1.76-1.58-2.05-.16-.28-.02-.44.12-.58.12-.12.28-.32.42-.48.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.64-1.53-.88-2.1-.23-.55-.47-.47-.64-.48l-.55-.01c-.19 0-.49.07-.75.35-.26.28-1 1-1 2.44 0 1.44 1.03 2.83 1.17 3.03.14.19 2 3.18 4.86 4.46.68.3 1.21.48 1.62.62.68.22 1.3.19 1.79.12.55-.08 1.7-.69 1.94-1.36.24-.66.24-1.22.17-1.35-.07-.12-.26-.2-.54-.34Z" />
      </svg>
    </span>
    <span className="drawer-social-text">WhatsApp</span>
  </a>
</div>
          </aside>
        </>
      )}
    </>
  );
}

export default Header;